import InternalStaticAnchorDashboard from 'models/application/anchor/types/internalStatic/types/Dashboard';

export default class InternalStaticAnchorDashboardService {
	toModel() {
		return new InternalStaticAnchorDashboard();
	}
}
